import { render, staticRenderFns } from "./PGPView.vue?vue&type=template&id=21f928ef&scoped=true"
import script from "./PGPView.vue?vue&type=script&lang=js"
export * from "./PGPView.vue?vue&type=script&lang=js"
import style0 from "./PGPView.vue?vue&type=style&index=0&id=21f928ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f928ef",
  null
  
)

export default component.exports